<template>
    <div class="container">
        <div class="search" style="display: flex">
            <el-form
                ref="queryFormRef"
                style="flex: 1"
                :inline="true"
                :model="search"
                class="demo-form-inline"
                size="mini"
            >
                <el-form-item label="uuid：" prop="uuid">
                    <el-input
                        v-model.trim="search.uuid"
                        placeholder=" "
                        @keyup.enter.native="Search"
                    ></el-input>
                </el-form-item>
                <el-form-item label="型号：" prop="model">
                    <SearchInnerModel
                        v-model="search.model"
                        @selectQuery="Search"
                    ></SearchInnerModel>
                </el-form-item>
                <el-form-item label="mac地址：" prop="mac">
                    <el-input
                        v-model.trim="search.mac"
                        placeholder=" "
                        @keyup.enter.native="Search"
                    ></el-input>
                </el-form-item>
                <el-form-item label="sn序号：" prop="sn">
                    <el-input
                        v-model.trim="search.sn"
                        placeholder=" "
                        @keyup.enter.native="Search"
                    ></el-input>
                </el-form-item>
                <el-form-item label="批次：" prop="token">
                    <el-input
                        v-model.trim="search.token"
                        placeholder=" "
                        @keyup.enter.native="Search"
                    ></el-input>
                </el-form-item>
                <el-form-item label="版本：" prop="version">
                    <el-input
                        v-model.trim="search.version"
                        placeholder=" "
                        @keyup.enter.native="Search"
                    ></el-input>
                </el-form-item>
                <el-form-item label="红外：" prop="ircut">
                    <el-select
                        v-model="search.ircut"
                        placeholder=" "
                        clearable
                        @change="Search"
                    >
                        <el-option label="0" :value="1" />
                        <el-option label="1" :value="2" />
                    </el-select>
                </el-form-item>
                <el-form-item label="云台：" prop="ptz">
                    <el-select
                        v-model="search.ptz"
                        placeholder=" "
                        clearable
                        @change="Search"
                    >
                        <el-option label="0" :value="1" />
                        <el-option label="1" :value="2" />
                    </el-select>
                </el-form-item>
                <el-form-item label="按键：" prop="key">
                    <el-select
                        v-model="search.key"
                        placeholder=" "
                        clearable
                        @change="Search"
                    >
                        <el-option label="0" :value="1" />
                        <el-option label="1" :value="2" />
                    </el-select>
                </el-form-item>
                <el-form-item label="wifi强度：" prop="min_wifi">
                    <el-input-number v-model="search.min_wifi" />
                    ~
                    <el-input-number v-model="search.max_wifi" />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        style="margin-left: 16px"
                        class="btnClass"
                        @click="Search"
                        >搜索</el-button
                    >
                    <el-button
                        type="text"
                        class="textBtn"
                        style="padding-bottom: 0px; vertical-align: bottom"
                        @click="clearCondition"
                        >重置</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <!-- 列表 -->
        <el-table :data="list" size="mini">
            <el-table-column label="uuid" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.uuid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="型号" width="100">
                <template v-slot="scope">
                    <span>{{ scope.row.model }}</span>
                </template>
            </el-table-column>
            <el-table-column label="sn序号" width="90">
                <template v-slot="scope">
                    <span>{{ scope.row.sn }}</span>
                </template>
            </el-table-column>
            <el-table-column label="mac地址">
                <template v-slot="scope">
                    <span>{{ scope.row.mac }}</span>
                </template>
            </el-table-column>
            <el-table-column label="版本">
                <template v-slot="scope">
                    <span>{{ scope.row.version }}</span>
                </template>
            </el-table-column>
            <el-table-column label="红外" width="60">
                <template v-slot="scope">
                    <span>{{ scope.row.ircut }}</span>
                </template>
            </el-table-column>
            <el-table-column label="云台" width="60">
                <template v-slot="scope">
                    <span>{{ scope.row.ptz }}</span>
                </template>
            </el-table-column>
            <el-table-column label="按键" width="60">
                <template v-slot="scope">
                    <span>{{ scope.row.key }}</span>
                </template>
            </el-table-column>
            <el-table-column label="wifi强度" width="80">
                <template v-slot="scope">
                    <span>{{ scope.row.wifi }}</span>
                </template>
            </el-table-column>
            <el-table-column label="测试时间戳" width="105">
                <template v-slot="scope">
                    <span>{{ scope.row.test_ts }}</span>
                </template>
            </el-table-column>
            <el-table-column label="烧录时间戳" width="105">
                <template v-slot="scope">
                    <span>{{ scope.row.burn_ts }}</span>
                </template>
            </el-table-column>
            <el-table-column label="批次">
                <template v-slot="scope">
                    <span>{{ scope.row.token }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="创建时间(UTC)"
                width="115"
                prop="create_time"
            >
                <template v-slot="scope">
                    <span>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="更新时间(UTC)"
                width="115"
                prop="updated_at"
            >
                <template v-slot="scope">
                    <span>{{ scope.row.updated_at }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            v-model:currentPage="search.page"
            :page-size="search.rows"
            layout="total, prev, pager, next"
            :total="total"
            background
        >
        </el-pagination>
    </div>
</template>

<script type="text/ecmascript-6">
import api from '../../axios/productionManage'
import util from "../../util/util"
import SearchInnerModel from '../../components/device/SearchInnerModel.vue'
import SearchCountryList from '../../components/device/SearchCountryList.vue'

export default {
    name: "",
    mixins: [],
    components: {
        SearchInnerModel,
        SearchCountryList
    },
    props: {},
    data() {
        return {
            util: util,
            search: {
                page: 1,
                rows: 16,
                uuid: '',
                token: '',
                model: '',
                sn: '',
                mac: '',
                version: '',
                ircut: undefined,
                ptz: undefined,
                key: undefined,
                min_wifi: undefined,
                max_wifi: undefined
            },
            list: [],
            total: 0
        }
    },
    computed: {},
    watch: {},
    methods: {
        getTimestamp(date) {
            return +date.getTime().toString().slice(0, 10)
        },
        handleCurrentChange(val) {
            this.search.page = val
            this.query()
        },
        Search() {
            this.search.page = 1
            this.query()
        },
        query() {
            api
                .DeviceTrackList({
                    data: {
                        ...this.search,
                        ircut: this.search.ircut === '' ? undefined : this.search.ircut,
                        ptz: this.search.ptz === '' ? undefined : this.search.ptz,
                        key: this.search.key === '' ? undefined : this.search.key
                    },
                    region: 'gb',
                    payload_version: 'v1.0'
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.total = res.data.data.total
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        clearCondition() {
            this.reset()
            this.Search()
        },
        reset() {
            this.search = {
                ...this.search,
                uuid: '',
                token: '',
                model: '',
                sn: '',
                mac: '',
                version: '',
                ircut: undefined,
                ptz: undefined,
                key: undefined,
                min_wifi: undefined,
                max_wifi: undefined
            }
        },
    },
    filters: {},
    mounted() {
        this.Search()
    },
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  .search {
    background: #F0F2F5;
    padding-top: 16px;
    margin-bottom: 24px;
  }

  .el-form {
    ::v-deep(.el-form-item__label) {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
      padding-right: 0px;
    }

    .el-form-item {
      margin-left: 24px;
    }
  }

  .btnClass {
    color: #FFF;
    background-color: #FB6D07;
    border-color: #FB6D07;
  }

  .textBtn {
    color: #FB6D07;
  }

  ::v-deep(thead) {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000;
    opacity: 0.8;

    th {
      font-weight: 400;
      background-color: #F0F2F5;
    }
  }

  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }
}
</style>
